import React, { useEffect, useState } from 'react';
import { InfinitySpin } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { GetAllMajorCategory } from '../../../redux/admin/category/category_services_syn';
import { Skeleton } from '@mui/material';
import { updateMajorCategoryImageDetails } from '../../../redux/admin/major_category/major_category_slices';
import { CreateMajorCategory } from '../../../redux/admin/major_category/major_category_services_sync';

const baseSchema = Yup.object({
  name: Yup.string().required(),
  slug: Yup.string(),
  description: Yup.string(),
});

const Create_Major_Category = () => {
  const dispatch = useDispatch();

  const { majorCategoryImageDetails, major_category_loader } = useSelector(
    (state) => state.major_category
  );

  const { category_loader, completeMajorCategory } = useSelector(
    (state) => state.category
  );

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (major_category_loader) return;

    const payload = {
      ...value,
      category_image: majorCategoryImageDetails?.secure_url,
      category_image_id: majorCategoryImageDetails?.public_id,
    };

    await dispatch(CreateMajorCategory({ ...payload }));

    resetForm();

    // router.push('/admin_dashboard/users');
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: '',
      slug: '',
      description: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  useEffect(() => {
    dispatch(GetAllMajorCategory());

    return () => {};
  }, []);

  return (
    <>
      <div class="row">
        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  {/* <form>
                    <div class="mb-3">
                      <label for="category-title" class="form-label">
                        Category Title
                      </label>
                      <input
                        type="text"
                        id="category-title"
                        class="form-control"
                        placeholder="Enter Name"
                        value={values.name || ''}
                        onChange={handleChange}
                        name="name"
                        style={{
                          border: errors.name && '1px solid red',
                        }}
                      />
                    </div>
                  </form> */}
                  {category_loader ? (
                    <Skeleton height={80} width={'100%'} count={1} />
                  ) : (
                    <form>
                      <label for="product-categories" class="form-label">
                        Category Title
                      </label>
                      <select
                        class="form-control"
                        id="product-categories"
                        data-choices
                        data-choices-groups
                        data-placeholder="Select Categories"
                        name="choices-single-groups"
                        onChange={(e) => {
                          const findDetails = completeMajorCategory?.find(
                            (item) => item?.name === e.target.value
                          );

                          if (findDetails) {
                            setFieldValue('name', findDetails?.name);
                            setFieldValue('slug', findDetails?.slug);
                            setFieldValue(
                              'description',
                              findDetails?.description
                            );

                            dispatch(
                              updateMajorCategoryImageDetails({
                                secure_url: findDetails?.category_image,
                                public_id: findDetails?.category_image_id,
                              })
                            );
                          }
                        }}
                        style={{
                          border: errors.category && '1px solid red',
                        }}
                      >
                        <option value="">Choose a categories</option>
                        {completeMajorCategory?.map((item, key) => (
                          <option key={key} value={item?.name}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </form>
                  )}
                </div>

                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-id" class="form-label">
                        Slug
                      </label>
                      <input
                        type="text"
                        id="slug"
                        class="form-control"
                        placeholder="Category Slug"
                        value={values.slug || ''}
                        onChange={handleChange}
                        disabled
                        name="slug"
                        style={{
                          border: errors.slug && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-12">
                  <div class="mb-0">
                    <label for="description" class="form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Type description"
                      value={values.description || ''}
                      onChange={handleChange}
                      disabled
                      name="description"
                      style={{
                        border: errors.description && '1px solid red',
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Meta Options</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <form>
                        <div class="mb-3">
                          <label for="meta-title" class="form-label">
                            Meta Title
                          </label>
                          <input
                            type="text"
                            id="meta-title"
                            class="form-control"
                            placeholder="Enter Title"
                          />
                        </div>
                      </form>
                    </div>
                    <div class="col-lg-6">
                      <form>
                        <div class="mb-3">
                          <label for="meta-tag" class="form-label">
                            Meta Tag Keyword
                          </label>
                          <input
                            type="text"
                            id="meta-tag"
                            class="form-control"
                            placeholder="Enter word"
                          />
                        </div>
                      </form>
                    </div>
                    <div class="col-lg-12">
                      <div class="mb-0">
                        <label for="description" class="form-label">
                          Description
                        </label>
                        <textarea
                          class="form-control bg-light-subtle"
                          id="description"
                          rows="4"
                          placeholder="Type description"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Save Change
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {major_category_loader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Upload Category</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create_Major_Category;
